import GHProfileCard from './GHProfileCard';
import reducers, { save } from './store';

export default GHProfileCard;
export { reducers, save };



// WEBPACK FOOTER //
// ./src/GHProfileCard/index.js